/* ネームここから */
/* ネーム見本：項目そのものを細工せず専用の枠に入れる・説明文を残す・閉じた時は隠す 2026.10.23 */
/* 見本と注記を1つの包み（wrap）に入れ、見本の下に注記を右寄せで出す 2026.10.23 */
/* 字体・モチーフのバンド（.japlish-font-band）をネームが開いている時だけ出す 2026.10.23 */
(function () {
  'use strict';

  var fontLinkId = 'japlish-preview-fonts';

  if (!document.getElementById(fontLinkId)) {
    var link = document.createElement('link');
    link.id = fontLinkId;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400;1,700&family=Cinzel+Decorative:wght@400;700&family=Smokum&family=Sorts+Mill+Goudy:ital@0;1&display=swap';
    document.head.appendChild(link);
  }

  var FONT_OPTION_MIN_HEIGHT = 48; /* 字体の候補欄1行の高さ(px)。他の候補欄（アプリCSSの48px）に揃えた 2026.10.25 */
  var FONT_LABEL_STYLE = 'paren'; /* 字体欄の表記：'paren' か 'colon' 2026.10.24 */

  var fontMap = {
    '彫刻': '"Libre Baskerville", serif',
    '彫刻文字': '"Libre Baskerville", serif',
    '彫刻体': '"Libre Baskerville", serif',
    '万能彫刻体': '"Libre Baskerville", serif',
    'Libre Baskerville': '"Libre Baskerville", serif',
    'Cinzel Decorative': '"Libre Baskerville", serif',
    'シック斜体': '"Sorts Mill Goudy", serif',
    '斜体': '"Sorts Mill Goudy", serif',
    'サーカス字': '"Smokum", serif',
    'サーカス': '"Smokum", serif',
    'Della Robbia': '"Cinzel Decorative", serif',
    'Della Robbia Italic': '"Cinzel Decorative", serif',
    'Goudy Old Style Italic': '"Sorts Mill Goudy", serif',
    'Goudy Italic': '"Sorts Mill Goudy", serif',
    'gaudy itaric': '"Sorts Mill Goudy", serif',
    'Goudy Old Style': '"Sorts Mill Goudy", serif',
    'Sorts Mill Goudy': '"Sorts Mill Goudy", serif',
    'Smokum': '"Smokum", serif',
    'PT Barnum': '"Smokum", serif',
    'PT. Barnum': '"Smokum", serif'
  };

  var fontStyleMap = {
    'シック斜体': 'italic',
    '斜体': 'italic',
    'Della Robbia Italic': 'italic',
    'Goudy Old Style Italic': 'italic',
    'Goudy Italic': 'italic',
    'gaudy itaric': 'italic'
  };

  var leatherBackgrounds = {
    'キャメル': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ca_9f4eae2f-6e1c-42af-930f-d3ead6ee597e.png?v=1792504065',
    'チョコ': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ch_519866ef-a2d5-4e0e-9382-84d0ffbb629f.png?v=1792504065',
    'グリーン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-gr_8bd1c939-f867-407f-a998-65af365767f1.png?v=1792504065',
    'レッド': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-rd_043e3fa6-7d9b-41cc-9009-b30ec6928479.png?v=1792504066',
    'ブラック': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-bk_ef72f2e3-18ff-4eb5-a2e2-d8881b0c205a.png?v=1792504066',
    'グレー': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-fg_4c34bc24-9372-453a-8504-f345cb2adc27.png?v=1792504065',
    'ブラウン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-br_d70cd9fa-b703-40e8-ae13-69c44783a892.png?v=1792504065',
    'オリーブ': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ob_1ddaa34a-d74b-4464-bbbe-379525f2aae4.png?v=1792504065',
    'ワイン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-wn_31b88e6d-de8a-4320-b110-4174eb447a27.png?v=1792504065',
    'ネイビー': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-nv-2.png?v=1792504373'
  };

  var motifImages = {
    'プロペラ': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/PROPERA.png?v=1792504728',
    'プロペラ機': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/PROPERA.png?v=1792504728',
    '船': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/SHIP.png?v=1792504728'
  };

  var goldGradient = 'linear-gradient(180deg, #FFFBE2 0%, #FFEBA0 18%, #D9B34D 35%, #FFF8D2 48%, #F7DF91 62%, #E8C65F 78%, #FFF9DC 100%)';

  var silverGradient = 'linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 20%, #C4C4C4 36%, #FFFFFF 49%, #F4F4F4 64%, #D6D6D6 80%, #FFFFFF 100%)';

  var foilStyles = {
    '金の箔押し': {
      color: '#D9B84E',
      background: goldGradient
    },
    '銀の箔押し': {
      color: '#D0D0D0',
      background: silverGradient
    },
    '素押し': {
      color: '#50392A',
      background: 'none'
    }
  };

  var invalidPattern = /[^A-Za-z0-9 .,?!]/;

  /* 注記「※画像はイメージのため…」は出さない（不要のため削除）。アプリ側の説明文はJSが置き換えるので表示されない 2026.10.24 */
  var fontPickerObserver = null;
  var observedFontPicker = null;

  /* ネームの位置の画像：製品画像から「name-space」を含むファイルを探す。見つかった製品だけ、見本の下に「縫製位置を見る」のリンクを出し、押すと元の画像をポップアップで見せる。普段は閉じているので、カートまでの距離は変わらない 2026.10.24 */
  var NAME_SPACE_KEYWORD = 'name-space';
  var NAME_SPACE_LINK_TEXT = 'この製品のネームプレート縫製位置を見る';
  var NAME_SPACE_POPUP_WIDTH = 1000;

  var nameSpaceCache = {};

  /* 商品ハンドルをURLから読む（取得用。test- も付いたまま）2026.10.24 */
  function getRawHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  /* 横幅だけを指定したURLにする。すでにあるサイズ指定は外してから付け直す。切り抜きの指定は付けない 2026.10.24 */
  function sizedImageUrl(url, width) {
    var text = String(url || '');

    if (text.indexOf('//') === 0) text = location.protocol + text;

    text = text.replace(/_\d+x\d*(\.[A-Za-z0-9]+)(\?|$)/, '$1$2');

    return text.replace(/(\.[A-Za-z0-9]+)(\?|$)/, '_' + width + 'x$1$2');
  }

  /* 画面にすでにある製品画像から探す（取得に失敗した時の予備）2026.10.24 */
  function findNameSpaceInPage() {
    var img = document.querySelector(
      'img[src*="' + NAME_SPACE_KEYWORD + '"], img[data-src*="' + NAME_SPACE_KEYWORD + '"]'
    );

    if (!img) return '';
    return img.getAttribute('data-src') || img.currentSrc || img.getAttribute('src') || '';
  }

  /* 製品データ（/products/ハンドル.js）から、name-space を含む画像を探す。結果は製品ごとに覚える 2026.10.24 */
  function fetchNameSpace(handle, done) {
    if (Object.prototype.hasOwnProperty.call(nameSpaceCache, handle)) {
      done(nameSpaceCache[handle]);
      return;
    }

    function finish(url) {
      nameSpaceCache[handle] = url || '';
      done(nameSpaceCache[handle]);
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var list = [];

        if (data && data.images) list = list.concat(data.images);

        if (data && data.media) {
          data.media.forEach(function (item) {
            if (item && item.src) list.push(item.src);
          });
        }

        var found = '';

        for (var i = 0; i < list.length; i++) {
          if (String(list[i]).toLowerCase().indexOf(NAME_SPACE_KEYWORD) !== -1) {
            found = list[i];
            break;
          }
        }

        finish(found || findNameSpaceInPage());
      })
      .catch(function () {
        finish(findNameSpaceInPage());
      });
  }

  /* ポップアップを閉じる。ページのスクロールと、押したリンクへのフォーカスを元に戻す 2026.10.24 */
  var nameSpacePopupState = null;

  function closeNameSpacePopup() {
    var state = nameSpacePopupState;
    if (!state) return;

    nameSpacePopupState = null;

    document.removeEventListener('keydown', state.onKey, true);

    if (state.overlay.parentNode) state.overlay.parentNode.removeChild(state.overlay);

    document.body.style.overflow = state.bodyOverflow;

    if (state.trigger && typeof state.trigger.focus === 'function') {
      try { state.trigger.focus(); } catch (error) {}
    }
  }

  /* ポップアップを開く。画像は元の比率のまま、画面に収まる大きさで出す 2026.10.24 */
  function openNameSpacePopup(url, trigger) {
    closeNameSpacePopup();

    var overlay = document.createElement('div');
    overlay.id = 'japlish-name-space-popup';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'ネームプレート縫製位置');
    overlay.style.cssText =
      'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;' +
      'display:flex;align-items:center;justify-content:center;box-sizing:border-box;' +
      'padding:16px;background:rgba(0,0,0,0.6);';

    var box = document.createElement('div');
    box.style.cssText =
      'position:relative;display:block;max-width:100%;max-height:100%;' +
      'line-height:0;background:#fff;border-radius:8px;overflow:hidden;';

    var img = document.createElement('img');
    img.alt = 'ネームプレート縫製位置';
    img.src = sizedImageUrl(url, NAME_SPACE_POPUP_WIDTH);
    img.style.cssText =
      'display:block;width:auto;height:auto;max-width:min(92vw, 640px);' +
      'max-height:86vh;object-fit:contain;';

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', '閉じる');
    close.textContent = '×';
    close.style.cssText =
      'position:absolute;top:8px;right:8px;width:32px;height:32px;margin:0;padding:0;' +
      'border:1px solid #999;border-radius:50%;background:rgba(255,255,255,0.92);' +
      'color:#333;font-size:20px;line-height:30px;text-align:center;cursor:pointer;';

    box.appendChild(img);
    box.appendChild(close);
    overlay.appendChild(box);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeNameSpacePopup();
    });

    close.addEventListener('click', closeNameSpacePopup);

    var onKey = function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        closeNameSpacePopup();
      }
    };

    document.addEventListener('keydown', onKey, true);

    nameSpacePopupState = {
      overlay: overlay,
      onKey: onKey,
      trigger: trigger,
      bodyOverflow: document.body.style.overflow
    };

    document.body.style.overflow = 'hidden';
    document.body.appendChild(overlay);

    try { close.focus(); } catch (error) {}
  }

  /* 「縫製位置を見る」のリンク。画像が見つかるまで隠しておく 2026.10.24 */
  function createNameSpaceLink() {
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'japlish-name-space-link';
    link.style.cssText =
      'display:none;align-items:center;gap:6px;align-self:flex-end;margin:10px 0 0;' +
      'padding:4px 0;border:0;background:none;color:#333;font:inherit;' +
      'font-size:13px;font-weight:700;line-height:1.5;text-align:right;' +
      'text-decoration:underline;cursor:pointer;';

    link.innerHTML =
      '<span class="japlish-name-space-link-text"></span>' +
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8a1c10" ' +
      'stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<circle cx="10" cy="10" r="6.5"/><path d="M15 15 L21 21"/></svg>';

    link.querySelector('.japlish-name-space-link-text').textContent = NAME_SPACE_LINK_TEXT;

    link.addEventListener('click', function () {
      var url = link.dataset.src;
      if (url) openNameSpacePopup(url, link);
    });

    return link;
  }

  function loadNameSpace(link) {
    var handle = getRawHandle();
    if (!handle) return;

    fetchNameSpace(handle, function (url) {
      if (!url) {
        link.style.setProperty('display', 'none');
        return;
      }

      link.dataset.src = url;
      link.style.setProperty('display', 'inline-flex');

      /* ポップアップを開いた時にすぐ出るよう、画像を先に読んでおく */
      var preload = new Image();
      preload.src = sizedImageUrl(url, NAME_SPACE_POPUP_WIDTH);
    });
  }

  /* ネームプレートの見本を「×」で閉じる。閉じた後は「プレビューを開く」を残す。名前・字体・箔・モチーフを変えると開き直す 2026.10.24 */
  function setNamePreviewClosed(wrap, closed) {
    var stage = wrap.querySelector('.japlish-preview-stage');
    var reopen = wrap.querySelector('.japlish-preview-reopen');

    wrap.dataset.previewClosed = closed ? '1' : '';

    if (stage) stage.style.setProperty('display', closed ? 'none' : 'block');
    if (reopen) reopen.style.setProperty('display', closed ? 'inline-block' : 'none');
  }

  function reopenNamePreview() {
    var wrap = document.querySelector('.name-preview .japlish-preview-wrap');

    if (wrap && wrap.dataset.previewClosed === '1') {
      setNamePreviewClosed(wrap, false);
    }
  }

  var nameInputSelector =
    '.child-name input[type="text"], ' +
    '.name-bag input[type="text"], ' +
    '.name-goods-short input[type="text"], ' +
    '.name-goods-long input[type="text"]';

  function normalizeName(value) {
    return value
      .replace(/[！-～]/g, function (character) {
        return String.fromCharCode(character.charCodeAt(0) - 0xFEE0);
      })
      .replace(/\u3000/g, ' ');
  }

  function normalizeNameInput(input) {
    if (!input) return;

    var original = input.value || '';
    var normalized = normalizeName(original);

    if (original !== normalized) {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      input.value = normalized;

      if (typeof start === 'number' && typeof end === 'number') {
        try {
          input.setSelectionRange(
            normalizeName(original.slice(0, start)).length,
            normalizeName(original.slice(0, end)).length
          );
        } catch (error) {}
      }
    }
  }

  function getNameInput() {
    return document.querySelector(
      '#infiniteoptions-container .child-name input[type="text"], ' +
      '#infiniteoptions-container .name-bag input[type="text"], ' +
      '#infiniteoptions-container .name-goods-short input[type="text"], ' +
      '#infiniteoptions-container .name-goods-long input[type="text"]'
    ) || document.querySelector(nameInputSelector);
  }

  function getOptionElement(optionClass, fallbackSelectors) {
    var wrapper = document.querySelector('.' + optionClass);

    if (wrapper) {
      var select = wrapper.querySelector('select');
      if (select) return select;

      var checked = wrapper.querySelector('input:checked');
      if (checked) return checked;

      var input = wrapper.querySelector('input');
      if (input) return input;
    }

    for (var i = 0; i < fallbackSelectors.length; i++) {
      var element = document.querySelector(fallbackSelectors[i]);
      if (element) return element;
    }

    return null;
  }

  function getOptionValue(optionClass, fallbackSelectors) {
    var element = getOptionElement(optionClass, fallbackSelectors);
    if (!element) return '';

    if (element.tagName === 'SELECT') {
      var option = element.options[element.selectedIndex];
      return option ? option.text.trim() : element.value.trim();
    }

    return (element.value || '').trim();
  }

  function getFontInfo(value) {
    var text = String(value || '').trim();
    var lower = text.toLowerCase();

    if (
      lower.indexOf('libre baskerville') !== -1 ||
      lower.indexOf('cinzel decorative') !== -1 ||
      /彫刻/.test(text)
    ) {
      return {
        id: lower.indexOf('libre baskerville') !== -1
          ? 'Libre Baskerville'
          : 'Cinzel Decorative',
        title: '彫刻体',
        label: '彫刻体', /* 表示名は余裕があるので「体」付きに戻した 2026.10.24 */
        family: '"Libre Baskerville", serif',
        style: 'normal',
        previewName: '彫刻体'
      };
    }

    if (
      lower.indexOf('sorts mill goudy') !== -1 ||
      lower.indexOf('goudy old style italic') !== -1 ||
      lower.indexOf('goudy italic') !== -1 ||
      lower.indexOf('gaudy itaric') !== -1 ||
      /シック斜体|斜体|イタリック/.test(text)
    ) {
      return {
        id: 'Sorts Mill Goudy',
        title: '斜体',
        label: 'イタリック',
        family: '"Sorts Mill Goudy", serif',
        style: 'italic',
        previewName: '斜体'
      };
    }

    if (
      lower.indexOf('smokum') !== -1 ||
      lower.indexOf('pt. barnum') !== -1 ||
      lower.indexOf('pt barnum') !== -1 ||
      /サーカス字|サーカス/.test(text)
    ) {
      return {
        id: 'Smokum',
        title: 'サーカス',
        label: 'サーカス体',
        family: '"Smokum", serif',
        style: 'normal',
        previewName: 'サーカス'
      };
    }

    return null;
  }

  function renderFontPickerLabel(labelElement, fontValue) {
    if (!labelElement) return;

    var info = getFontInfo(fontValue);
    if (!info) return;

    if (
      labelElement.dataset.japlishRenderedFont === info.id &&
      labelElement.querySelector('.japlish-fontpicker-description') &&
      labelElement.querySelector('.japlish-fontpicker-sample')
    ) return;

    var description = document.createElement('span');
    description.className = 'japlish-fontpicker-description';
    /* 候補欄の字体名は label（彫刻体→彫刻）で出す。内部の判定は title のまま 2026.10.24 */
    /* 並びは「見本 → 字体名」（他の欄の「画像 → 文字」に合わせた）。形は FONT_LABEL_STYLE で切り替える：'paren'＝M.Kato 12.24（彫刻体）／'colon'＝M.Kato 12.24：彫刻体 2026.10.24 */
    description.textContent = FONT_LABEL_STYLE === 'colon'
      ? '：' + info.label
      : '（' + info.label + '）';
    description.style.setProperty('font-family', 'Arial, sans-serif', 'important');
    description.style.setProperty('font-size', 'calc(1em - 2px)', 'important');
    description.style.setProperty('font-style', 'normal', 'important');
    description.style.setProperty('font-weight', '400', 'important');
    description.style.setProperty('white-space', 'pre', 'important');
    description.style.setProperty('display', 'inline', 'important');
    description.style.setProperty('color', 'inherit', 'important');

    var sample = document.createElement('span');
    sample.className = 'japlish-fontpicker-sample';
    sample.textContent = 'M.Kato 12.24';
    sample.style.setProperty('font-family', info.family, 'important');
    sample.style.setProperty('font-style', info.style, 'important');
    /* 彫刻の見本だけ大きく見えて候補欄に収まらないため 16px → 15px に小さくした 2026.10.24 */
    /* スマホで候補欄がきついため、彫刻体 15px → 14px、イタリックは元の大きさ −1px（calc(1em - 1px)）にした 2026.10.24 */
    sample.style.setProperty(
      'font-size',
      info.title === '彫刻体'
        ? '14px'
        : info.title === '斜体'
          ? 'calc(1em - 1px)'
          : 'inherit',
      'important'
    );
    sample.style.setProperty(
      'font-weight',
      info.title === 'サーカス' ? '400' : '700',
      'important'
    );
    sample.style.setProperty('white-space', 'pre', 'important');
    sample.style.setProperty('display', 'inline', 'important');
    sample.style.setProperty('color', 'inherit', 'important');

    labelElement.replaceChildren(sample, description);
    labelElement.style.setProperty('font-family', 'Arial, sans-serif', 'important');
    labelElement.style.setProperty('font-style', 'normal', 'important');
    labelElement.style.setProperty('font-size', 'inherit', 'important');
    labelElement.style.setProperty('display', 'inline-flex', 'important');
    labelElement.style.setProperty('align-items', 'baseline', 'important');
    labelElement.style.setProperty('gap', '0', 'important');
    labelElement.style.setProperty('white-space', 'nowrap', 'important');
    labelElement.dataset.japlishRenderedFont = info.id;
  }

  function getFontPickerRoot() {
    return document.querySelector(
      '#infiniteoptions-container .name-font-selector .spb-fontpicker'
    ) || document.querySelector(
      '.name-font-selector .spb-fontpicker'
    );
  }

  function getSelectedFontId(root) {
    if (!root) return '';

    var selectedButton = root.querySelector(
      '.spb-fontpicker-option[aria-selected="true"]'
    );

    if (selectedButton) {
      var selectedDataFont = selectedButton.getAttribute('data-font');
      if (selectedDataFont) return selectedDataFont;
    }

    var nativeSelect = root.querySelector('select.spb-fontpicker-native');

    if (nativeSelect) {
      var selectedOption = nativeSelect.options[nativeSelect.selectedIndex];

      if (selectedOption) {
        return selectedOption.getAttribute('data-font') ||
          selectedOption.value ||
          selectedOption.textContent;
      }
    }

    var summaryLabel = root.querySelector('.spb-fontpicker-selected-label');

    if (summaryLabel) {
      var familyInfo = getFontInfo(summaryLabel.style.fontFamily || '');

      if (familyInfo) return familyInfo.id;
      return summaryLabel.textContent || '';
    }

    return '';
  }

  function isPlaceholderFont(value) {
    var text = String(value || '').trim().toLowerCase();

    return !text ||
      /^(choose a font|select a font|choose font|select font|フォントを選択)$/.test(text);
  }

  function fontPickerHasSelection(root) {
    if (!root) return false;

    var selectedButton = root.querySelector(
      '.spb-fontpicker-option[aria-selected="true"][data-font]'
    );

    if (
      selectedButton &&
      getFontInfo(selectedButton.getAttribute('data-font'))
    ) return true;

    var nativeSelect = root.querySelector('select.spb-fontpicker-native');

    if (nativeSelect && nativeSelect.selectedIndex >= 0) {
      var selectedOption = nativeSelect.options[nativeSelect.selectedIndex];

      if (selectedOption) {
        var optionValue = selectedOption.getAttribute('data-font') ||
          selectedOption.value ||
          selectedOption.textContent;

        if (!isPlaceholderFont(optionValue) && getFontInfo(optionValue)) {
          return true;
        }
      }
    }

    var summaryLabel = root.querySelector('.spb-fontpicker-selected-label');

    if (summaryLabel && !isPlaceholderFont(summaryLabel.textContent)) {
      return Boolean(
        getFontInfo(summaryLabel.style.fontFamily) ||
        getFontInfo(summaryLabel.textContent)
      );
    }

    return false;
  }

  function applyNativeDefaultFont(root) {
    if (!root) return false;

    var nativeSelect = root.querySelector('select.spb-fontpicker-native');
    if (!nativeSelect) return false;

    var targetIndex = -1;

    for (var i = 0; i < nativeSelect.options.length; i++) {
      var option = nativeSelect.options[i];
      var fontValue = option.getAttribute('data-font') ||
        option.value ||
        option.textContent;

      var info = getFontInfo(fontValue);

      if (info && info.title === '彫刻体') {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex < 0) return false;

    nativeSelect.selectedIndex = targetIndex;
    nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
    nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

    var selectedOption = nativeSelect.options[targetIndex];
    var selectedValue = selectedOption.getAttribute('data-font') ||
      selectedOption.value ||
      selectedOption.textContent;

    var selectedButton = Array.prototype.find.call(
      root.querySelectorAll('.spb-fontpicker-option[data-font]'),
      function (button) {
        return button.getAttribute('data-font') === selectedValue;
      }
    );

    if (selectedButton) {
      root.querySelectorAll('.spb-fontpicker-option').forEach(function (button) {
        button.setAttribute(
          'aria-selected',
          button === selectedButton ? 'true' : 'false'
        );
      });
    }

    return true;
  }

  function ensureDefaultFontSelection(root) {
    root = root || getFontPickerRoot();
    if (!root || fontPickerHasSelection(root)) return;

    if (root.dataset.japlishDefaultFontAttempted === 'true') {
      if (applyNativeDefaultFont(root)) {
        root.dataset.japlishDefaultFontAttempted = 'done';
      }
      return;
    }

    root.dataset.japlishDefaultFontAttempted = 'true';

    var options = Array.prototype.slice.call(
      root.querySelectorAll('.spb-fontpicker-option[data-font]')
    );

    var firstButton = options.find(function (button) {
      var info = getFontInfo(button.getAttribute('data-font'));
      return info && info.title === '彫刻体';
    }) || options[0];

    if (firstButton) firstButton.click();

    window.setTimeout(function () {
      var currentRoot = getFontPickerRoot();
      if (!currentRoot || fontPickerHasSelection(currentRoot)) return;

      if (applyNativeDefaultFont(currentRoot)) {
        currentRoot.dataset.japlishDefaultFontAttempted = 'done';
      }

      updateFontPickerDisplay();

      var input = getNameInput();
      if (input) updateNamePreview(input);
    }, 50);
  }

  /* 字体欄が「画像付きのプルダウン」（選択肢＝彫刻／斜体／サーカス）の場合の対応。値が日本語で注文に入る。候補欄は本物のフォントの見本で描く 2026.10.24 */
  function getFontDropdownRoot() {
    return document.querySelector(
      '#infiniteoptions-container .name-font-selector .spb-imagedropdown'
    ) || document.querySelector('.name-font-selector .spb-imagedropdown');
  }

  function getSelectedFontDropdownValue(root) {
    if (!root) return '';

    var selected = root.querySelector('.spb-imagedropdown-option[aria-selected="true"]');

    if (selected) return selected.getAttribute('data-value') || '';

    var nativeSelect = root.querySelector('select');

    if (nativeSelect && nativeSelect.selectedIndex >= 0) {
      var option = nativeSelect.options[nativeSelect.selectedIndex];
      var text = option ? (option.value || option.textContent || '').trim() : '';

      if (getFontInfo(text)) return text;
    }

    return '';
  }

  /* 空の枠（画像なし）が左に残らないよう隠す。この欄だけ 2026.10.24 */
  function addFontDropdownStyle() {
    var id = 'japlish-name-font-dropdown-style';
    if (document.getElementById(id)) return;

    var style = document.createElement('style');
    style.id = id;
    style.textContent =
      '.name-font-selector .spb-imagedropdown-chip--empty { display: none !important; }';

    document.head.appendChild(style);
  }

  /* 最初に何も選ばれていなければ、「彫刻」を選ぶ。欄が見えている時だけ 2026.10.24 */
  function ensureDefaultFontDropdown(root) {
    if (!root || getSelectedFontDropdownValue(root)) return;
    if (!root.getClientRects().length) return;
    if (root.dataset.japlishDefaultFontDropdown === '1') return;

    var options = Array.prototype.slice.call(
      root.querySelectorAll('.spb-imagedropdown-option[data-value]')
    );

    var first = options.find(function (option) {
      var info = getFontInfo(option.getAttribute('data-value'));
      return info && info.title === '彫刻体';
    }) || options[0];

    if (!first) return;

    root.dataset.japlishDefaultFontDropdown = '1';
    first.click();
  }

  function updateFontDropdownDisplay() {
    var root = getFontDropdownRoot();
    if (!root) return;

    addFontDropdownStyle();
    ensureDefaultFontDropdown(root);

    root.querySelectorAll('.spb-imagedropdown-option[data-value]').forEach(function (option) {
      var label = option.querySelector('.spb-imagedropdown-optionlabel');
      renderFontPickerLabel(label, option.getAttribute('data-value'));

      /* 候補欄の行が詰まって見えるため、行の高さを他の画像付き欄に近づける。CSSの!importantに負けないようJSで直接指定 2026.10.24 */
      option.style.setProperty('min-height', FONT_OPTION_MIN_HEIGHT + 'px', 'important');
      option.style.setProperty('padding-top', '8px', 'important');
      option.style.setProperty('padding-bottom', '8px', 'important');
      option.style.setProperty('box-sizing', 'border-box', 'important');
      option.style.setProperty('align-items', 'center', 'important');
    });

    var value = getSelectedFontDropdownValue(root);

    if (value) {
      renderFontPickerLabel(
        root.querySelector('.spb-imagedropdown-selected-label'),
        value
      );
    }
  }

  function updateFontPickerDisplay() {
    var root = getFontPickerRoot();

    /* 旧：フォント選択（fontpicker）が無ければ、画像付きプルダウン版を処理する 2026.10.24 */
    if (!root) {
      updateFontDropdownDisplay();
      return;
    }

    ensureDefaultFontSelection(root);

    root.querySelectorAll('.spb-fontpicker-option').forEach(function (button) {
      var fontValue = button.getAttribute('data-font') || '';
      var label = button.querySelector('.spb-fontpicker-optionlabel');

      renderFontPickerLabel(
        label,
        fontValue || (label ? label.textContent : '')
      );
    });

    var selectedFontId = getSelectedFontId(root);

    if (isPlaceholderFont(selectedFontId)) {
      selectedFontId = 'Libre Baskerville';
    }

    var selectedLabel = root.querySelector('.spb-fontpicker-selected-label');
    renderFontPickerLabel(selectedLabel, selectedFontId);
  }

  function observeFontPicker() {
    var root = document.querySelector(
      '#infiniteoptions-container .name-font-selector'
    ) || document.querySelector('.name-font-selector');

    if (!root || observedFontPicker === root) return;

    if (fontPickerObserver) fontPickerObserver.disconnect();

    observedFontPicker = root;

    fontPickerObserver = new MutationObserver(function () {
      updateFontPickerDisplay();

      window.setTimeout(function () {
        var input = getNameInput();
        if (input) updateNamePreview(input);
      }, 0);
    });

    fontPickerObserver.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-selected', 'data-font', 'style']
    });

    updateFontPickerDisplay();
  }

  function getFontSelection() {
    var dropdownValue = getSelectedFontDropdownValue(getFontDropdownRoot());
    var dropdownInfo = dropdownValue ? getFontInfo(dropdownValue) : null;

    if (dropdownInfo) return dropdownInfo.previewName;

    var root = getFontPickerRoot();
    var selectedId = getSelectedFontId(root);
    var info = getFontInfo(selectedId);

    if (!info) {
      var fallback = document.querySelector(
        '#infiniteoptions-container .name-font-selector select.spb-fontpicker-native, ' +
        '.name-font-selector select.spb-fontpicker-native'
      );

      if (fallback) {
        var option = fallback.options[fallback.selectedIndex];

        info = getFontInfo(
          option
            ? option.getAttribute('data-font') || option.value || option.textContent
            : fallback.value
        );
      }
    }

    return info ? info.previewName : getOptionValue('name-font-selector', [
      'select[name="properties[フォント]"]',
      'select[name*="フォント"]',
      'select[id*="フォント"]',
      'select[name*="font"]',
      'select[id*="font"]'
    ]);
  }

  function getLeatherColor() {
    var select = document.querySelector('[data-handle="色"] select');

    if (!select) {
      select = document.querySelector(
        'select[name*="色"], select[id*="色"]'
      );
    }

    if (!select) return 'キャメル';

    var selected = select.options[select.selectedIndex];
    return selected ? selected.text.trim() : select.value.trim();
  }

  function updateNameWarning(input) {
    var container = input.parentElement;
    if (!container) return;

    var warningLine = container.querySelector('.japlish-name-warning-line');
    var warning = container.querySelector('.japlish-name-warning');
    var marked = container.querySelector('.japlish-invalid-preview');

    if (!warningLine) {
      warningLine = document.createElement('div');
      warningLine.className = 'japlish-name-warning-line';
      warningLine.style.cssText =
        'display:none;width:100%;min-width:0;margin:0 0 4px;padding:0;' +
        'flex-direction:column;align-items:flex-start;justify-content:flex-start;' +
        'gap:2px;flex-wrap:nowrap;white-space:normal;line-height:1.5;' +
        'box-sizing:border-box;overflow:visible;';
    }

    if (!warning) {
      warning = document.createElement('span');
      warning.className = 'japlish-name-warning';
    }

    warning.textContent = '利用不可な文字が含まれています';
    warning.style.cssText =
      'display:block;flex:none;width:auto;max-width:100%;' +
      'margin:0;padding:0;color:#D93025;font-size:12px;' +
      'font-weight:600;line-height:1.5;white-space:normal;';

    if (!marked) {
      marked = document.createElement('span');
      marked.className = 'japlish-invalid-preview';
    }

    marked.style.cssText =
      'display:block;flex:none;width:max-content;min-width:0;' +
      'max-width:none;margin:0;padding:0;font-size:14px;' +
      'line-height:1.5;white-space:nowrap;overflow:visible;' +
      'text-overflow:clip;vertical-align:baseline;';

    if (warningLine.parentElement !== container) {
      container.insertBefore(warningLine, input);
    }

    if (warning.parentElement !== warningLine) {
      warningLine.appendChild(warning);
    }

    if (marked.parentElement !== warningLine) {
      warningLine.appendChild(marked);
    }

    var value = input.value || '';
    var hasInvalid = invalidPattern.test(value);

    warningLine.style.display = hasInvalid ? 'flex' : 'none';
    marked.replaceChildren();

    var validText = '';

    function appendValidText() {
      if (validText) {
        marked.appendChild(document.createTextNode(validText));
        validText = '';
      }
    }

    Array.from(value).forEach(function (character) {
      if (invalidPattern.test(character)) {
        appendValidText();

        var span = document.createElement('span');
        span.textContent = character;
        span.style.cssText = 'color:#D93025;';
        marked.appendChild(span);
      } else {
        validText += character;
      }
    });

    appendValidText();
  }

  function updateNamePreview(input) {
    var heading = document.querySelector('.name-preview');
    if (!heading || !input) return;

    var name = input.value || '';
    var fontName = getFontSelection();

    var foilName = getOptionValue('name-haku', [
      'select[name="properties[箔の選択]"]',
      'select[id*="箔"]'
    ]);

    var motifName = getOptionValue('name-motif', [
      'select[name="properties[モチーフ]"]',
      'select[id^="モチーフ"]',
      'select[name*="モチーフ"]'
    ]);

    var leatherColor = getLeatherColor();
    var font = fontMap[fontName] || '"Libre Baskerville", serif';
    var fontStyle = fontStyleMap[fontName] || 'normal';

    var fontSize = (fontName === '彫刻体' || fontName === '彫刻')
      ? '22.3px'
      : fontName === '斜体'
        ? '25.5px'
        : fontName === 'サーカス'
          ? '21.76px'
          : '24.4px';

    var foil = foilStyles[foilName] || foilStyles['金の箔押し'];
    var backgroundImage = leatherBackgrounds[leatherColor] ||
      leatherBackgrounds['キャメル'];

    /* 見本は専用の枠（pill）に入れる。項目そのもの（heading）には表示・高さを強制しない 2026.10.23 */
    var pill = heading.querySelector('.japlish-preview-pill');

    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'japlish-preview-pill';

      /* 見本と、縫製位置のリンクを縦に積む包み。項目の枠が横並びでも、包みが全幅を取る 2026.10.23 */
      var wrap = document.createElement('div');
      wrap.className = 'japlish-preview-wrap';
      wrap.style.cssText =
        'display:none;flex-direction:column;align-items:flex-end;' +
        'flex:1 1 100%;width:100%;min-width:0;max-width:100%;' +
        'margin:0;padding:0;box-sizing:border-box;';

      /* 見本（pill）と、右上の「×」を同じ枠に入れる。pill は overflow:hidden なので「×」は外に置く 2026.10.24 */
      var stage = document.createElement('div');
      stage.className = 'japlish-preview-stage';
      /* 右に×用の34pxを空け、×は見本の外（右上）に置く。見本には重ねない 2026.10.24 */
      stage.style.cssText = 'position:relative;display:block;align-self:flex-end;max-width:100%;padding-right:34px;box-sizing:border-box;';

      var closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'japlish-preview-close';
      closeButton.setAttribute('aria-label', 'ネームのプレビューを閉じる'); /* 文言を変更 2026.10.26 */
      closeButton.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false"><path d="M2 2L10 10M10 2L2 10" fill="none" stroke="#333" stroke-width="1.6" stroke-linecap="round"/></svg>'; /* ×は線の図形で描く。文字だと下にずれる 2026.10.24 */
      closeButton.style.cssText =
        'position:absolute;top:0;right:0;z-index:2;width:24px;height:24px;margin:0;padding:0;' +
        'border:1px solid #999;border-radius:50%;background:#fff;' +
        'display:flex;align-items:center;justify-content:center;line-height:0;color:#333;cursor:pointer;';

      closeButton.addEventListener('click', function () {
        setNamePreviewClosed(wrap, true);
      });

      stage.appendChild(pill);
      stage.appendChild(closeButton);

      var reopenButton = document.createElement('button');
      reopenButton.type = 'button';
      reopenButton.className = 'japlish-preview-reopen';
      reopenButton.textContent = 'ネームのプレビューを開く'; /* 「プレビューを開く」から変更 2026.10.26 */
      reopenButton.style.cssText =
        'display:none;align-self:flex-end;margin:0;padding:4px 0;border:0;background:none;' +
        'color:#666;font:inherit;font-size:12px;line-height:1.5;text-decoration:underline;cursor:pointer;';

      reopenButton.addEventListener('click', function () {
        setNamePreviewClosed(wrap, false);
      });

      /* 見本の下に、ネームの位置を見るリンクを入れる 2026.10.24 */
      var nameSpaceLink = createNameSpaceLink();

      wrap.appendChild(stage);
      wrap.appendChild(reopenButton);
      wrap.appendChild(nameSpaceLink);
      heading.replaceChildren(wrap);
      loadNameSpace(nameSpaceLink);
    }

    var textElement = pill.querySelector('.japlish-preview-text');

    if (!textElement) {
      textElement = document.createElement('span');
      textElement.className = 'japlish-preview-text';
      pill.appendChild(textElement);
    }

    var motifElement = pill.querySelector('.japlish-preview-motif');

    if (!motifElement) {
      motifElement = document.createElement('span');
      motifElement.className = 'japlish-preview-motif';
      pill.appendChild(motifElement);
    }

    textElement.textContent = name;
    textElement.style.display = name.length ? 'inline-block' : 'none';
    textElement.style.flex = '0 0 auto';
    textElement.style.fontFamily = font;
    textElement.style.fontStyle = fontStyle;
    textElement.style.fontSize = fontSize;
    textElement.style.lineHeight = '1.2';
    textElement.style.whiteSpace = 'pre';
    textElement.style.width = 'max-content';
    textElement.style.maxWidth = 'none';
    textElement.style.margin = '0';
    textElement.style.padding = '0';
    textElement.style.position = 'static';
    textElement.style.alignSelf = 'center';

    if (foilName === '素押し') {
      textElement.style.backgroundImage = 'none';
      textElement.style.color = foil.color;
      textElement.style.webkitTextFillColor = foil.color;
      textElement.style.backgroundClip = 'border-box';
      textElement.style.webkitBackgroundClip = 'border-box';
    } else {
      textElement.style.backgroundImage = foil.background;
      textElement.style.backgroundSize = '100% 100%';
      textElement.style.backgroundRepeat = 'no-repeat';
      textElement.style.backgroundClip = 'text';
      textElement.style.webkitBackgroundClip = 'text';
      textElement.style.color = 'transparent';
      textElement.style.webkitTextFillColor = 'transparent';
    }

    var motifSelected = Boolean(motifName && motifImages[motifName]);

    if (motifSelected) {
      motifElement.style.display = 'inline-block';
      motifElement.style.width = '48px';
      motifElement.style.height = '48px';
      motifElement.style.flex = '0 0 48px';
      motifElement.style.alignSelf = 'center';
      motifElement.style.position = 'static';
      motifElement.style.backgroundColor = foil.color;
      motifElement.style.webkitMaskImage =
        'url("' + motifImages[motifName] + '")';
      motifElement.style.maskImage =
        'url("' + motifImages[motifName] + '")';
      motifElement.style.webkitMaskRepeat = 'no-repeat';
      motifElement.style.maskRepeat = 'no-repeat';
      motifElement.style.webkitMaskPosition = 'center';
      motifElement.style.maskPosition = 'center';
      motifElement.style.webkitMaskSize = 'contain';
      motifElement.style.maskSize = 'contain';
      motifElement.style.transform = 'none';
      motifElement.style.margin = '0';
      motifElement.style.padding = '0';
      motifElement.style.backgroundImage = foil.background;
    } else {
      motifElement.style.display = 'none';
      motifElement.style.backgroundImage = 'none';
      motifElement.style.webkitMaskImage = 'none';
      motifElement.style.maskImage = 'none';
      motifElement.style.margin = '0';
    }

    /* 枠（pill）の見た目。出し入れは包み（wrap）側で行う 2026.10.23 */
    pill.style.setProperty('display', 'flex', 'important');
    pill.style.setProperty('position', 'static', 'important');
    pill.style.setProperty('float', 'none', 'important');
    pill.style.setProperty('clear', 'none', 'important');
    pill.style.setProperty('flex-direction', 'row', 'important');
    pill.style.setProperty('align-items', 'center', 'important');
    pill.style.setProperty('justify-content', 'center', 'important');
    pill.style.setProperty('gap', '7px', 'important');
    pill.style.setProperty('width', 'fit-content', 'important');
    pill.style.setProperty('min-width', '150px', 'important');
    pill.style.setProperty('max-width', '100%', 'important');
    pill.style.setProperty('height', '58px', 'important');
    pill.style.setProperty('min-height', '58px', 'important');
    pill.style.setProperty('box-sizing', 'border-box', 'important');
    pill.style.setProperty('padding', '5px 18px', 'important');
    pill.style.setProperty('margin-left', 'auto', 'important');
    pill.style.setProperty('margin-right', '0', 'important');
    pill.style.setProperty('white-space', 'nowrap', 'important');
    pill.style.setProperty('border-radius', '999px', 'important');
    pill.style.setProperty('overflow', 'hidden', 'important');
    pill.style.setProperty(
      'background-image',
      'url("' + backgroundImage + '")',
      'important'
    );
    pill.style.setProperty('background-size', 'cover', 'important');
    pill.style.setProperty('background-position', 'center', 'important');

    if (!name.length && !motifSelected) {
      pill.style.setProperty('width', '150px', 'important');
      pill.style.setProperty('min-width', '150px', 'important');
      pill.style.setProperty('height', '58px', 'important');
      pill.style.setProperty('min-height', '58px', 'important');
      pill.style.setProperty('padding', '0', 'important');
    }

    syncPreviewVisibility();
  }

  /* ネーム欄が開いている時だけ、見本・注記・字体モチーフのバンドを出す。閉じている時は場所も取らない 2026.10.23 */
  function syncPreviewVisibility() {
    var input = getNameInput();
    var isOpen = Boolean(input && input.getClientRects().length);

    /* 字体・モチーフのバンド（Liquid側の部品）。最初は非表示、開いたら表示 */
    var band = document.querySelector('.japlish-font-band');

    if (band) {
      var bandDisplay = isOpen ? 'block' : 'none';

      if (band.style.display !== bandDisplay) {
        band.style.display = bandDisplay;
      }
    }

    var wrap = document.querySelector('.name-preview .japlish-preview-wrap');
    if (!wrap) return;

    var wrapDisplay = isOpen ? 'flex' : 'none';

    if (wrap.style.getPropertyValue('display') !== wrapDisplay) {
      wrap.style.setProperty('display', wrapDisplay, 'important');
    }
  }

  function initPreview() {
    updateFontPickerDisplay();
    observeFontPicker();

    var input = getNameInput();
    if (!input) return;

    normalizeNameInput(input);
    updateNameWarning(input);
    updateNamePreview(input);
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches(nameInputSelector)) {
      reopenNamePreview();
      normalizeNameInput(event.target);
      updateNameWarning(event.target);
      updateNamePreview(event.target);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches(
      '.name-font-selector select, .name-font-selector input, ' +
      '.name-font select, .name-haku select, .name-motif select, ' +
      '.name-font input, .name-haku input, .name-motif input, ' +
      'select[name="properties[モチーフ]"], select[id^="モチーフ"], ' +
      'select[name*="モチーフ"], select[name*="字体"], select[id*="字体"], ' +
      'select[name*="箔"], select[id*="箔"], ' +
      '[data-handle="色"] select, select[name*="色"], select[id*="色"]'
    )) {
      reopenNamePreview();
      updateFontPickerDisplay();
      initPreview();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest(
      '.name-font-selector, .name-font, .name-haku, .name-motif, ' +
      '[class*="name-font-selector"], [class*="name-font"], ' +
      '[class*="name-haku"], [class*="name-motif"]'
    )) {
      [0, 50, 250].forEach(function (delay) {
        window.setTimeout(function () {
          updateFontPickerDisplay();
          initPreview();
        }, delay);
      });
    }
  });

  /* ネームの開閉に合わせて見本・注記・バンドを出し入れする 2026.10.23 */
  ['change', 'click'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest('#infiniteoptions-container')) {
        [0, 100, 300].forEach(function (delay) {
          window.setTimeout(syncPreviewVisibility, delay);
        });
      }
    });
  });

  window.addEventListener('resize', initPreview);

  function start() {
    updateFontPickerDisplay();
    observeFontPicker();
    initPreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ネームプレートここまで*/



/* ABC INITIAL PREVIEW */
/* 2026.10.26：欄が現れた直後（まだ何も押していない時）も、画像（文字・色見本）を出す。これまでは、欄の中を押すまで出なかった。変化の見張りを追加し、書き換えは「変わった時だけ」にした（点滅防止） */
/* 2026.10.26：ABCの選択は、画像（文字）と文字が重複するため、文字を見えなくした（HTMLには残す。カート・注文は変わらない） */
(function () {
  'use strict';

  var ROOT_ID = 'japlish-abc-style';
  var FONT_ID = 'japlish-abc-orbitron';

  var COLORS = [
    { name: '白', hex: '#FCF9F2' },
    { name: '赤', hex: '#DE0913' },
    { name: '緑', hex: '#029656' },
    { name: '黒', hex: '#2E2D2D' },
    { name: 'カーキ', hex: '#706939' },
    { name: '茶', hex: '#67361D' },
    { name: '金', hex: '#F5DC38' },
    { name: '水色', hex: '#38A0FF' },
    { name: '紺', hex: '#1A2D56' },
    { name: '紫', hex: '#7F16A6' },
    { name: '黄', hex: '#FCF00A' },
    { name: 'ブルーグレー', hex: '#718AAB' }
  ];

  var updateQueued = false;

  function addFont() {
    if (document.getElementById(FONT_ID)) return;

    var link = document.createElement('link');
    link.id = FONT_ID;
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700;800&display=swap';

    document.head.appendChild(link);
  }

  function addStyles() {
    var oldStyle = document.getElementById(ROOT_ID);
    if (oldStyle) oldStyle.remove();

    var style = document.createElement('style');
    style.id = ROOT_ID;

    style.textContent = `
      .abc-color .japlish-abc-color-chip {
        display: inline-block !important;
        width: 24px !important;
        height: 24px !important;
        min-width: 24px !important;
        min-height: 24px !important;
        margin: 0 4px 0 0 !important;
        padding: 0 !important;
        border: 1px solid #aaa !important;
        border-radius: 0 !important;
        box-sizing: border-box !important;
        flex: 0 0 24px !important;
        background-image: none !important;
      }

      .abc-color .spb-imagedropdown-option,
      .abc-color .spb-imagedropdown-selected {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
      }

      .abc-color .spb-imagedropdown-chip--empty,
      .abc-letter .spb-imagedropdown-chip--empty {
        display: none !important;
      }

      .abc-letter .spb-imagedropdown-option,
      .abc-letter .spb-imagedropdown-selected {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
      }

      .abc-letter .japlish-abc-letter-preview {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 24px !important;
        min-width: 24px !important;
        height: 24px !important;
        line-height: 24px !important;
        margin: 0 !important;
        padding: 0 !important;
        font-family: "Orbitron", sans-serif !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        flex: 0 0 24px !important;
        box-sizing: border-box !important;
      }

      /* 画像（文字）がある時だけ、同じ文字を見えなくする 2026.10.26 */
      .abc-letter .japlish-abc-letter-preview ~ .spb-imagedropdown-selected-label,
      .abc-letter .japlish-abc-letter-preview ~ .spb-imagedropdown-optionlabel {
        position: absolute !important;
        width: 1px !important;
        min-width: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
      }

      .abc-letter .spb-imagedropdown-selected-label {
        display: inline-flex !important;
        align-items: center !important;
        height: 24px !important;
        line-height: 24px !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #222 !important;
        font-family: inherit !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        vertical-align: middle !important;
        box-sizing: border-box !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getWrapper(className) {
    return document.querySelector(
      '#infiniteoptions-container .' + className
    ) || document.querySelector('.' + className);
  }

  function getSelectedLabel(wrapper) {
    return wrapper
      ? wrapper.querySelector('.spb-imagedropdown-selected-label')
      : null;
  }

  function getValue(element) {
    if (!element) return '';

    return (
      element.getAttribute('data-value') ||
      element.getAttribute('aria-label') ||
      element.textContent ||
      ''
    ).trim();
  }

  function findColor(value) {
    var text = String(value || '').trim().toLowerCase();

    return COLORS.find(function (color) {
      return color.name.toLowerCase() === text ||
        color.hex.toLowerCase() === text;
    }) || null;
  }

  function addColorChip(parent, color) {
    if (!parent || !color) return;

    var chip = parent.querySelector(
      ':scope > .japlish-abc-color-chip'
    );

    if (!chip) {
      chip = document.createElement('span');
      chip.className = 'japlish-abc-color-chip';
      chip.setAttribute('aria-hidden', 'true');
      parent.insertBefore(chip, parent.firstChild);
    }

    /* 色が変わった時だけ書き換える 2026.10.26 */
    if (chip.getAttribute('data-japlish-hex') !== color.hex) {
      chip.style.setProperty(
        'background-color',
        color.hex,
        'important'
      );

      chip.setAttribute('data-japlish-hex', color.hex);
    }
  }

  function decorateColorOptions(wrapper) {
    if (!wrapper) return;

    wrapper.querySelectorAll(
      '.spb-imagedropdown-option'
    ).forEach(function (option) {
      var color = findColor(getValue(option));
      if (color) addColorChip(option, color);
    });
  }

  function decorateSelectedColor(wrapper) {
    if (!wrapper) return;

    var selected = wrapper.querySelector(
      '.spb-imagedropdown-selected'
    );

    var color = findColor(getValue(getSelectedLabel(wrapper)));

    if (!selected || !color) return;

    addColorChip(selected, color);

    var emptyChip = selected.querySelector(
      '.spb-imagedropdown-chip--empty'
    );

    if (emptyChip) emptyChip.remove();
  }

  function getLetter(element) {
    if (!element) return '';

    var value = element.getAttribute('data-value');
    if (value && /^[A-Z]$/i.test(value.trim())) {
      return value.trim();
    }

    value = element.getAttribute('aria-label');
    if (value && /^[A-Z]$/i.test(value.trim())) {
      return value.trim();
    }

    var clone = element.cloneNode(true);

    clone.querySelectorAll(
      '.japlish-abc-letter-preview, .japlish-abc-letter-text'
    ).forEach(function (child) {
      child.remove();
    });

    var text = clone.textContent.trim();
    var match = text.match(/[A-Z]/i);

    return match ? match[0] : '';
  }

  function decorateLetter(container, color) {
    if (!container) return;

    var label = container.classList.contains(
      'spb-imagedropdown-selected-label'
    ) ? container : container.querySelector(
      '.spb-imagedropdown-selected-label'
    );

    var letter = getLetter(label);

    if (!letter && container.classList.contains(
      'spb-imagedropdown-option'
    )) {
      letter = getLetter(container);
    }

    if (!letter) return;

    var preview = container.querySelector(
      ':scope > .japlish-abc-letter-preview'
    );

    if (!preview) {
      preview = document.createElement('span');
      preview.className = 'japlish-abc-letter-preview';
      container.insertBefore(preview, container.firstChild);
    }

    /* 文字・色が変わった時だけ書き換える（変化の見張りが、自分の書き換えで回り続けないため）2026.10.26 */
    if (preview.textContent !== letter) {
      preview.textContent = letter;
    }

    var isWhite = !color || color.name === '白';
    var previewKey = (color ? color.hex : COLORS[0].hex) + '|' + isWhite;

    if (preview.getAttribute('data-japlish-key') !== previewKey) {
      preview.style.setProperty(
        'color',
        color ? color.hex : COLORS[0].hex,
        'important'
      );

      preview.style.setProperty(
        '-webkit-text-stroke',
        isWhite ? '0.5px #c9c9c9' : '0px transparent',
        'important'
      );

      preview.setAttribute('data-japlish-key', previewKey);
    }

    if (label && label.getAttribute('data-japlish-styled') !== '1') {
      label.style.setProperty('color', '#222', 'important');
      label.style.setProperty('font-family', 'inherit', 'important');
      label.style.setProperty('font-size', '16px', 'important');
      label.style.setProperty('font-weight', '400', 'important');
      label.style.setProperty('line-height', '24px', 'important');
      label.style.setProperty('height', '24px', 'important');
      label.style.setProperty('display', 'inline-flex', 'important');
      label.style.setProperty('align-items', 'center', 'important');
      label.style.setProperty('margin', '0', 'important');
      label.style.setProperty('padding', '0', 'important');
      label.setAttribute('data-japlish-styled', '1');
    }
  }

  function decorateLetterOptions(wrapper, color) {
    if (!wrapper) return;

    wrapper.querySelectorAll(
      '.spb-imagedropdown-option'
    ).forEach(function (option) {
      decorateLetter(option, color);
    });
  }

  function decorateSelectedLetter(wrapper, color) {
    if (!wrapper) return;

    var selected = wrapper.querySelector(
      '.spb-imagedropdown-selected'
    );

    if (!selected) return;

    var emptyChip = selected.querySelector(
      '.spb-imagedropdown-chip--empty'
    );

    if (emptyChip) emptyChip.remove();

    decorateLetter(selected, color);
  }

  function removeDuplicateText(wrapper) {
    if (!wrapper) return;

    wrapper.querySelectorAll(
      '.japlish-abc-letter-text'
    ).forEach(function (element) {
      element.remove();
    });
  }

  function update() {
    var colorWrapper = getWrapper('abc-color');
    var letterWrapper = getWrapper('abc-letter');

    if (!colorWrapper || !letterWrapper) return;

    decorateColorOptions(colorWrapper);
    decorateSelectedColor(colorWrapper);

    var selectedColor = getSelectedLabel(colorWrapper);
    var color = findColor(getValue(selectedColor)) || COLORS[0];

    removeDuplicateText(letterWrapper);
    decorateLetterOptions(letterWrapper, color);
    decorateSelectedLetter(letterWrapper, color);
  }

  function scheduleUpdate() {
    window.setTimeout(update, 150);
    window.setTimeout(update, 400);
  }

  /* 欄が現れた時・表示された時・選択が変わった時に、押されなくても描き直す 2026.10.26 */
  var watchTimer = null;
  var containerObserver = null;
  var wrapperObserver = null;
  var watchedWrappers = [];

  function requestUpdate() {
    if (watchTimer) return;

    watchTimer = window.setTimeout(function () {
      watchTimer = null;
      watchWrappers();
      update();
    }, 80);
  }

  /* 欄そのものの style（非表示→表示）の変化を見張る。中身の style は見張らない（自分の書き換えで回らないため） */
  function watchWrappers() {
    ['abc-color', 'abc-letter'].forEach(function (name) {
      var wrapper = getWrapper(name);

      if (!wrapper || watchedWrappers.indexOf(wrapper) !== -1) return;

      if (!wrapperObserver) {
        wrapperObserver = new MutationObserver(requestUpdate);
      }

      wrapperObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ['style', 'class', 'disabled']
      });

      watchedWrappers.push(wrapper);
    });
  }

  function attachContainerObserver() {
    if (containerObserver) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    containerObserver = new MutationObserver(requestUpdate);
    containerObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    return true;
  }

  function start() {
    addFont();
    addStyles();
    update();

    document.addEventListener('click', function (event) {
      if (event.target.closest('.abc-color, .abc-letter')) {
        scheduleUpdate();
      }
    });

    /* アプリの描画が遅れても拾えるよう、入れ物が現れるまで待つ 2026.10.26 */
    if (!attachContainerObserver()) {
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;

        if (attachContainerObserver() || tries >= 40) {
          window.clearInterval(timer);
          requestUpdate();
        }
      }, 300);
    } else {
      requestUpdate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ABC イニシャル刺繍ここまで */




/* 三本線の色・線幅プレビューここから */
(function () {
  'use strict';

  var colors = {
    '白': '#FCF9F2',
    '赤': '#DE0913',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '金': '#F5DC38',
    '水色': '#38A0FF',
    '紺': '#1A2D56',
    '紫': '#7F16A6',
    '黄': '#FCF00A',
    'ブルーグレー': '#718AAB'
  };

  var lineWidth = 3.45;
  /* 白の縁を濃くした：#C9C9C9 → #999999、縁の太さ＋1 → ＋1.5（イカリ白と同じ）2026.10.24 */
  var whiteOutline = '#999999';
  var offset = 3;

  function getMotif(field) {
    var classes = [
      'horizontal-top',
      'horizontal-center',
      'horizontal-under',
      'vertical-left',
      'vertical-center',
      'vertical-right'
    ];

    for (var i = 0; i < classes.length; i++) {
      if (field.classList.contains(classes[i])) {
        return classes[i];
      }
    }

    return null;
  }

  function createSvg(type, color) {
    var path;
    var transform = '';

    switch (type) {
      case 'horizontal-top':
        path = 'M3 12 H21';
        transform = 'translate(0 -' + offset + ')';
        break;
      case 'horizontal-center':
        path = 'M3 12 H21';
        break;
      case 'horizontal-under':
        path = 'M3 12 H21';
        transform = 'translate(0 ' + offset + ')';
        break;
      case 'vertical-left':
        path = 'M12 3 V21';
        transform = 'translate(-' + offset + ' 0)';
        break;
      case 'vertical-center':
        path = 'M12 3 V21';
        break;
      case 'vertical-right':
        path = 'M12 3 V21';
        transform = 'translate(' + offset + ' 0)';
        break;
      default:
        return '';
    }

    /* 縁の線だけ両端に0.75ずつ延ばし、上下左右の四方を囲む 2026.10.24 */
    var outlinePath = path.charAt(1) === '3'
      ? 'M2.25 12 H21.75'
      : 'M12 2.25 V21.75';

    var outline = color === colors['白']
      ? '<path d="' + outlinePath + '" fill="none" stroke="' +
        whiteOutline + '" stroke-width="' + (lineWidth + 1.5) +
        '" stroke-linecap="butt"/>'
      : '';

    var line = '<path d="' + path + '" fill="none" stroke="' +
      color + '" stroke-width="' + lineWidth +
      '" stroke-linecap="butt"/>';

    return '<svg xmlns="http://www.w3.org/2000/svg" ' +
      'viewBox="0 0 24 24" width="27.6" height="27.6" ' +
      'aria-hidden="true" focusable="false">' +
      '<g transform="' + transform + '">' +
      outline + line +
      '</g></svg>';
  }

  function styleChip(chip, type, color) {
    if (!chip || !color) return;

    var svg = createSvg(type, color);
    if (!svg) return;

    if (chip.dataset.japlishMotifSvg !== svg) {
      chip.innerHTML = svg;
      chip.dataset.japlishMotifSvg = svg;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', '28px', 'important');
    chip.style.setProperty('height', '28px', 'important');
    chip.style.setProperty('min-width', '28px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function updateField(field) {
    var type = getMotif(field);
    if (!type) return;

    field.querySelectorAll(
      '.spb-imagedropdown-option[data-value]'
    ).forEach(function (option) {
      var color = colors[option.getAttribute('data-value')];
      var chip = option.querySelector('.spb-imagedropdown-chip');

      if (color && chip) {
        styleChip(chip, type, color);
      }
    });

    var selectedOption = field.querySelector(
      '.spb-imagedropdown-option[aria-selected="true"]'
    );

    var selectedChip = field.querySelector(
      '.spb-imagedropdown-selected .spb-imagedropdown-chip'
    );

    if (selectedOption && selectedChip) {
      var selectedColor = colors[
        selectedOption.getAttribute('data-value')
      ];

      if (selectedColor) {
        styleChip(selectedChip, type, selectedColor);
      }
    }
  }

  var updateQueued = false;

  function scheduleUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    window.setTimeout(function () {
      updateQueued = false;
      updateAll();
    }, 50);
  }

  function updateAll() {
    document.querySelectorAll(
      '#infiniteoptions-container .child-option'
    ).forEach(updateField);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches(
      '#infiniteoptions-container select.spb-imagedropdown-native'
    )) {
      scheduleUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest(
      '#infiniteoptions-container .spb-imagedropdown-option'
    )) {
      scheduleUpdate();
    }
  });

  var observer = new MutationObserver(scheduleUpdate);

  function startMotifPreview() {
    updateAll();

    var container = document.getElementById(
      'infiniteoptions-container'
    );

    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-selected']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMotifPreview);
  } else {
    startMotifPreview();
  }
})();
/* 三本線の色・線幅プレビューここまで */



/* イカリ刺繍11色プレビューここから */
(function () {
  'use strict';

  var colors = {
    '赤': '#DE0913',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '金': '#F5DC38',
    '水色': '#38A0FF',
    '紺': '#1A2D56',
    '紫': '#7F16A6',
    '黄': '#FCF00A',
    'ブルーグレー': '#718AAB'
  };

  var thin = 1.5;
  var normal = 2.25;

  function getAnchorPart(field) {
    if (field.classList.contains('anchor-top')) return 'top';
    if (field.classList.contains('anchor-center')) return 'center';
    if (field.classList.contains('anchor-under')) return 'under';
    return null;
  }

  function createSvg(part, color) {
    var paths = [];

    if (part === 'top') {
      paths.push({
        d: 'M12 5.2 L16.8 10 L12 14.8 L7.2 10 Z',
        width: thin
      });
    } else if (part === 'center') {
      paths.push({
        d: 'M5 8 H19',
        width: thin
      });
      paths.push({
        d: 'M12 8 V21',
        width: normal
      });
    } else if (part === 'under') {
      paths.push({
        d: 'M2.25 9.5 L7.5 16.5 Q12 23 16.5 16.5 L21.75 9.5',
        width: normal
      });
    }

    if (!paths.length) return '';

    var lines = paths.map(function (path) {
      return '<path d="' + path.d +
        '" fill="none" stroke="' + color +
        '" stroke-width="' + path.width +
        '" stroke-linecap="butt" stroke-linejoin="round"/>';
    }).join('');

    return '<svg xmlns="http://www.w3.org/2000/svg" ' +
      'viewBox="0 0 24 24" width="24" height="24" ' +
      'aria-hidden="true" focusable="false">' +
      lines + '</svg>';
  }

  function styleChip(chip, part, color) {
    if (!chip || !color) return;

    var svg = createSvg(part, color);
    if (!svg) return;

    if (chip.dataset.japlishAnchor11Svg !== svg) {
      chip.innerHTML = svg;
      chip.dataset.japlishAnchor11Svg = svg;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', '28px', 'important');
    chip.style.setProperty('height', '28px', 'important');
    chip.style.setProperty('min-width', '28px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function updateField(field) {
    var part = getAnchorPart(field);
    if (!part) return;

    field.querySelectorAll(
      '.spb-imagedropdown-option[data-value]'
    ).forEach(function (option) {
      var colorName = option.getAttribute('data-value');
      var color = colors[colorName];
      var chip = option.querySelector('.spb-imagedropdown-chip');

      if (color && chip) {
        styleChip(chip, part, color);
      }
    });

    var selectedOption = field.querySelector(
      '.spb-imagedropdown-option[aria-selected="true"]'
    );

    var selectedChip = field.querySelector(
      '.spb-imagedropdown-selected .spb-imagedropdown-chip'
    );

    if (selectedOption && selectedChip) {
      var selectedColor = colors[
        selectedOption.getAttribute('data-value')
      ];

      if (selectedColor) {
        styleChip(selectedChip, part, selectedColor);
      }
    }
  }

  var updateQueued = false;

  function scheduleUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    window.setTimeout(function () {
      updateQueued = false;
      updateAll();
    }, 50);
  }

  function updateAll() {
    document.querySelectorAll(
      '#infiniteoptions-container .child-option.anchor-top, ' +
      '#infiniteoptions-container .child-option.anchor-center, ' +
      '#infiniteoptions-container .child-option.anchor-under'
    ).forEach(updateField);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches(
      '#infiniteoptions-container select.spb-imagedropdown-native'
    )) {
      scheduleUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest(
      '#infiniteoptions-container .spb-imagedropdown-option'
    )) {
      scheduleUpdate();
    }
  });

  var observer = new MutationObserver(scheduleUpdate);

  function startAnchorPreview() {
    updateAll();

    var container = document.getElementById(
      'infiniteoptions-container'
    );

    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-selected']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnchorPreview);
  } else {
    startAnchorPreview();
  }
})();
/* イカリ刺繍11色プレビューここまで */


/* イカリ刺繍白プレビューここから */
(function () {
  'use strict';

  var white = '#FCF9F2';
  var whiteOutline = '#999999';
  var thin = 1.5;
  var normal = 2.25;

  function getAnchorPart(field) {
    if (field.classList.contains('anchor-top')) return 'top';
    if (field.classList.contains('anchor-center')) return 'center';
    if (field.classList.contains('anchor-under')) return 'under';
    return null;
  }

  function createSvg(part) {
    var paths = [];

    if (part === 'top') {
      paths.push({
        d: 'M12 5 L17 10 L12 15 L7 10 Z',
        width: thin
      });
    } else if (part === 'center') {
      paths.push({
        d: 'M5 8 H19',
        od: 'M4.25 8 H19.75',
        width: thin
      });
      paths.push({
        d: 'M12 8 V21',
        od: 'M12 8 V21.75',
        width: normal
      });
    } else if (part === 'under') {
      paths.push({
        d: 'M2.5 9.5 L7.5 16.5 Q12 23 16.5 16.5 L21.5 9.5',
        od: 'M2.06 8.89 L2.5 9.5 L7.5 16.5 Q12 23 16.5 16.5 L21.5 9.5 L21.94 8.89',
        width: normal
      });
    }

    if (!paths.length) return '';

    /* 縁用パス（od）があれば、それで描く。端を0.75延ばして四方を囲む 2026.10.24 */
    function renderPath(path, stroke, width, useOutline) {
      return '<path d="' + (useOutline && path.od ? path.od : path.d) +
        '" fill="none" stroke="' + stroke +
        '" stroke-width="' + width +
        '" stroke-linecap="butt" stroke-linejoin="round"/>';
    }

    var outline = paths.map(function (path) {
      return renderPath(path, whiteOutline, path.width + 1.5, true);
    }).join('');

    var colored = paths.map(function (path) {
      return renderPath(path, white, path.width);
    }).join('');

    return '<svg xmlns="http://www.w3.org/2000/svg" ' +
      'viewBox="0 0 24 24" width="25" height="25" ' +
      'aria-hidden="true" focusable="false" ' +
      'style="display:block;overflow:visible;flex-shrink:0">' +
      outline + colored + '</svg>';
  }

  function updateImage(img, part) {
    if (!img || !part || img.getAttribute('alt') !== '白') return;

    var parent = img.parentElement;
    if (!parent) return;

    var svg = createSvg(part);
    var existing = parent.querySelector(':scope > .japlish-anchor-white-preview');

    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'japlish-anchor-white-preview';
      existing.style.setProperty('display', 'inline-flex', 'important');
      existing.style.setProperty('align-items', 'center', 'important');
      existing.style.setProperty('justify-content', 'center', 'important');
      existing.style.setProperty('width', '28px', 'important');
      existing.style.setProperty('height', '28px', 'important');
      existing.style.setProperty('overflow', 'visible', 'important');
      img.insertAdjacentElement('afterend', existing);
    }

    if (existing.dataset.japlishAnchorWhiteSvg !== svg) {
      existing.innerHTML = svg;
      existing.dataset.japlishAnchorWhiteSvg = svg;
    }

    img.style.setProperty('display', 'none', 'important');
  }

  function updateField(field) {
    var part = getAnchorPart(field);
    if (!part) return;

    field.querySelectorAll('img.spb-imagedropdown-thumb[alt="白"]').forEach(function (img) {
      updateImage(img, part);
    });
  }

    var updateQueued = false;

  function scheduleUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    window.setTimeout(function () {
      updateQueued = false;
      updateAll();
    }, 50);
  }

  function updateAll() {
    document.querySelectorAll(
      '#infiniteoptions-container .child-option.anchor-top, ' +
      '#infiniteoptions-container .child-option.anchor-center, ' +
      '#infiniteoptions-container .child-option.anchor-under'
    ).forEach(updateField);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('#infiniteoptions-container')) {
      scheduleUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container')) {
      scheduleUpdate();
    }
  });

  var observer = new MutationObserver(scheduleUpdate);

  function startAnchorWhitePreview() {
    updateAll();

    var container = document.getElementById('infiniteoptions-container');

    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['alt', 'aria-selected']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnchorWhitePreview);
  } else {
    startAnchorWhitePreview();
  }
})();
/* イカリ刺繍白プレビューここまで */




/* Shopify公式バリエーション「色」画像付きプルダウン追加・4回目 */
(function () {
  'use strict';

  var STYLE_ID = 'japlish-color-dropdown-style';
  var WRAP_CLASS = 'japlish-color-image-wrap';

  var images = {
    'キャメル': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ca_9f4eae2f-6e1c-42af-930f-d3ead6ee597e.png?v=1792504065',
    'チョコ': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ch_519866ef-a2d5-4e0e-9382-84d0ffbb629f.png?v=1792504065',
    'グリーン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-gr_8bd1c939-f867-407f-a998-65af365767f1.png?v=1792504065',
    'レッド': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-rd_043e3fa6-7d9b-41cc-9009-b30ec6928479.png?v=1792504066',
    'ブラック': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-bk_ef72f2e3-18ff-4eb5-a2e2-d8881b0c205a.png?v=1792504066',
    'グレー': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-fg_4c34bc24-9372-453a-8504-f345cb2adc27.png?v=1792504065',
    'ブラウン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-br_d70cd9fa-b703-40e8-ae13-69c44783a892.png?v=1792504065',
    'オリーブ': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-ob_1ddaa34a-d74b-4464-bbbe-379525f2aae4.png?v=1792504065',
    'ワイン': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-wn_31b88e6d-de8a-4320-b110-4174eb447a27.png?v=1792504065',
    'ネイビー': 'https://cdn.shopify.com/s/files/1/0449/2302/7613/files/op-nv-2.png?v=1792504373'
  };

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${WRAP_CLASS} {
        position: relative;
        width: 100%;
      }

      .${WRAP_CLASS} > select[data-japlish-color-image-ready="true"] {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        min-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      .${WRAP_CLASS} .japlish-color-trigger {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 5px 34px 5px 12px;
        margin: 0;
        border: 1px solid #777;
        border-radius: 0;
        background: #fff;
        color: inherit;
        font: inherit;
        text-align: left;
        cursor: pointer;
      }

  

      .${WRAP_CLASS} .japlish-color-trigger::before {
        content: "";
        position: absolute;
        right: 14px;
        top: 50%;
        width: 8px;
        height: 8px;
        border-right: 1px solid currentColor;
        border-bottom: 1px solid currentColor;
        transform: translateY(-70%) rotate(45deg);
      }

      .${WRAP_CLASS} .japlish-color-trigger[aria-expanded="true"]::before {
        transform: translateY(-25%) rotate(225deg);
      }

      .${WRAP_CLASS} .japlish-color-selected-image,
      .${WRAP_CLASS} .japlish-color-option-image {
        display: block;
        width: 42px;
        height: 24px;
        flex: 0 0 42px;
        object-fit: cover;
      }

      .${WRAP_CLASS} .japlish-color-trigger-label {
        min-width: 0;
        margin-left: 12px;
      }

      .${WRAP_CLASS} .japlish-color-options {
        display: none;
        position: absolute;
        z-index: 1000;
        top: 100%;
        left: 0;
        width: 100%;
        max-height: 260px;
        overflow-y: auto;
        box-sizing: border-box;
        border: 1px solid #777;
        border-top: 0;
        background: #fff;
      }

      .${WRAP_CLASS} .japlish-color-options[data-open="true"] {
        display: block;
      }
.${WRAP_CLASS} .japlish-color-option {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  margin: 0;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 0;
  background: #fff;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

      .${WRAP_CLASS} .japlish-color-option:last-child {
        border-bottom: 0;
      }

      .${WRAP_CLASS} .japlish-color-option-label {
        margin-left: 12px;
      }

      .${WRAP_CLASS} .japlish-color-option[aria-selected="true"] {
        background: #f2f2f2;
      }
    `;
    document.head.appendChild(style);
  }

  function getColorName(option) {
    return option
      ? (option.value || option.textContent || '').trim()
      : '';
  }

  function isColorSelect(select) {
    var hasColor = Array.from(select.options).some(function (option) {
      return !!images[getColorName(option)];
    });

    if (!hasColor) return false;

    var wrapper = select.closest('.variant-wrapper');
    var label = wrapper && wrapper.querySelector('.variant__label');
    var labelText = label
      ? label.textContent.replace(/\s+/g, '').trim()
      : '';

    return /^(色|単色を選択|革色を選択|革色の選択)$/.test(labelText);
  }

  function build(select) {
    if (select.dataset.japlishColorImageReady === 'true') return;

    var wrapper = document.createElement('div');
    wrapper.className = WRAP_CLASS;
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    addStyles();
    select.dataset.japlishColorImageReady = 'true';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'japlish-color-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var selectedImage = document.createElement('img');
    selectedImage.className = 'japlish-color-selected-image';
    selectedImage.alt = '';
    selectedImage.setAttribute('aria-hidden', 'true');

    var selectedLabel = document.createElement('span');
    selectedLabel.className = 'japlish-color-trigger-label';

    trigger.appendChild(selectedImage);
    trigger.appendChild(selectedLabel);

    var list = document.createElement('div');
    list.className = 'japlish-color-options';
    list.setAttribute('role', 'listbox');
    list.dataset.open = 'false';

    var buttons = [];

    Array.from(select.options).forEach(function (option, index) {
      var name = getColorName(option);
      if (!images[name]) return;

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'japlish-color-option';
      item.setAttribute('role', 'option');
      item.dataset.index = String(index);
      item.dataset.value = option.value;

      var image = document.createElement('img');
      image.className = 'japlish-color-option-image';
      image.src = images[name];
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');

      var label = document.createElement('span');
      label.className = 'japlish-color-option-label';
      label.textContent = option.textContent.trim();

      item.appendChild(image);
      item.appendChild(label);
      list.appendChild(item);
      buttons.push(item);

      item.addEventListener('click', function () {
        select.selectedIndex = Number(item.dataset.index);
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        updateSelected();
        closeList();
        trigger.focus();
      });
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(list);

    function updateSelected() {
      var option = select.options[select.selectedIndex];
      var name = getColorName(option);

      selectedLabel.textContent = option ? option.textContent.trim() : '';

      if (images[name]) {
        selectedImage.src = images[name];
        selectedImage.style.display = '';
      } else {
        selectedImage.removeAttribute('src');
        selectedImage.style.display = 'none';
      }

      buttons.forEach(function (item) {
        item.setAttribute(
          'aria-selected',
          item.dataset.value === select.value ? 'true' : 'false'
        );
      });
    }

    function openList() {
      list.dataset.open = 'true';
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeList() {
      list.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      if (list.dataset.open === 'true') closeList();
      else openList();
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) closeList();
    });

    select.addEventListener('change', updateSelected);
    select.addEventListener('input', updateSelected);
    updateSelected();
  }

  function init() {
    document.querySelectorAll('select[data-variant-input]').forEach(function (select) {
      if (isColorSelect(select)) build(select);
    });
  }

  var queued = false;

  function scheduleInit() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      init();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldInit = mutations.some(function (mutation) {
      if (mutation.type !== 'childList') return false;

      var nodes = Array.from(mutation.addedNodes);

      return nodes.some(function (node) {
        if (node.nodeType !== 1) return false;

        return (
          node.matches('select[data-variant-input], .variant-wrapper') ||
          !!node.querySelector(
            'select[data-variant-input], .variant-wrapper'
          )
        );
      });
    });

    if (shouldInit) scheduleInit();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });


})();
/* Shopify公式バリエーション「色」画像付きプルダウン追加ここまで */

/* 子の欄（刺繍まわり）：隠れていた欄が表示された時に、先頭の候補へ戻すここから */
/* 2026.10.26：対象は、刺繍まわりの子の欄（class に child-option がある欄）だけ。ネーム（name-…）・糸（thread-…）・ツートン（two-tone）は対象外。
   親を別の値に変えて、子の欄が新しく現れる時だけ、先頭の候補を選び直す（アプリの普通の操作と同じ「先頭の候補を押す」ので、注文の値も更新される）。
   ・同じ親を押し直しただけ、字体を変えただけ（銀・船など、ずっと表示されている欄）は、隠れも現れもしないので、そのまま残る。
   ・文字入力（名前など）は、対象に入れない（プルダウン＝画像付きの欄だけ）。
   ・元に戻す時は、この「ここから」〜「ここまで」を消す */
(function () {
  'use strict';

  var FIELD_SELECTOR = '#infiniteoptions-container .child-option';
  /* 対象外：ネーム・糸・ツートンの欄 */
  var EXCLUDE_CLASS = /(^|\s)(name-[^\s]*|child-name|thread-[^\s]*|two-tone)(\s|$)/;
  var OPTION_SELECTOR = '.spb-imagedropdown-option';
  var states = new WeakMap();
  var timer = null;
  var observer = null;
  var attached = false;

  /* 2026.10.26：ページを開いた直後（お客さんがまだ何も触っていない間）は、戻さない。
     戻す時の「先頭の候補を押す」で、欄に focus が移り、補強糸の変更の見出しが赤茶の太字になっていたため。
     お客さんが最初に触ってから（本物の操作だけ）戻す。 */
  var userActed = false;

  ['pointerdown', 'touchstart', 'keydown'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.isTrusted) userActed = true;
    }, true);
  });

  /* 隠れている：disabled が付いている／表示領域が無い（display:none など） */
  function isHidden(field) {
    return field.hasAttribute('disabled') || field.getClientRects().length === 0;
  }

  function findFirstOption(field) {
    var options = field.querySelectorAll(OPTION_SELECTOR);

    for (var i = 0; i < options.length; i++) {
      if (!options[i].disabled && !options[i].hasAttribute('disabled')) return options[i];
    }

    return null;
  }

  function resetToFirst(field) {
    /* 隠れた間に、また隠れていたら、何もしない */
    if (isHidden(field)) return;

    var first = findFirstOption(field);
    if (!first) return;

    /* 押す前に focus がこの欄の外にあったなら、押したあと、この欄に移った focus は外す（見出しの赤茶・太字を残さない）2026.10.26 */
    var before = document.activeElement;
    var wasInside = before && field.contains(before);

    first.click();

    if (!wasInside) {
      [0, 80, 300].forEach(function (delay) {
        window.setTimeout(function () {
          var now = document.activeElement;

          if (now && now !== document.body && field.contains(now) && typeof now.blur === 'function') {
            now.blur();
          }
        }, delay);
      });
    }
  }

  function check() {
    timer = null;

    document.querySelectorAll(FIELD_SELECTOR).forEach(function (field) {
      if (EXCLUDE_CLASS.test(field.className)) return;

      /* 画像付きの候補を持つ欄だけ。子の欄をさらに束ねる外側の欄は除く */
      if (!field.querySelector(OPTION_SELECTOR)) return;
      if (field.querySelector('.child-option')) return;

      var hidden = isHidden(field);
      var before = states.get(field);

      states.set(field, hidden);

      /* 初めて見た時は、記録だけ。隠れていた → 表示された、の時だけ戻す */
      if (before === true && hidden === false && userActed) {
        window.setTimeout(function () {
          resetToFirst(field);
        }, 80);
      }
    });
  }

  function schedule() {
    if (timer) return;
    timer = window.setTimeout(check, 40);
  }

  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(schedule);
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'disabled']
    });

    attached = true;
    check();
    return true;
  }

  function start() {
    if (attach()) return;

    var tries = 0;
    var waiter = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(waiter);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 子の欄（刺繍まわり）：隠れていた欄が表示された時に、先頭の候補へ戻すここまで */

/* 文字数の表示（入力欄の上限）ここから */
/* 2026.10.26：アプリの「Character limits」で上限を決めた入力欄の下に、「3 / 9」を出す。上限に達したら、色を変えて「9文字以内にしてください」と出す（2026.10.26に文言を変更）。
   入力欄の maxlength（上限）を読む。maxlength が無い欄には、何も出さない。元に戻す時は、この「ここから」〜「ここまで」を消す */
(function () {
  'use strict';

  var STYLE_ID = 'japlish-charcount-style';
  var COUNT_CLASS = 'japlish-charcount';
  var FIELD_SELECTOR =
    '#infiniteoptions-container input[type="text"], #infiniteoptions-container textarea';
  var timer = null;
  var observer = null;
  var attached = false;

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.' + COUNT_CLASS + '{display:block;margin:2px 2px 0 0;text-align:right;' +
      'font-size:12px;line-height:1.4;color:#888;}' +
      '.' + COUNT_CLASS + '.is-limit{color:#a0391b;font-weight:600;}';

    document.head.appendChild(style);
  }

  function getLimit(input) {
    var limit = parseInt(input.getAttribute('maxlength'), 10);
    return limit > 0 ? limit : 0;
  }

  function getCounter(input) {
    var next = input.nextElementSibling;
    return next && next.classList.contains(COUNT_CLASS) ? next : null;
  }

  function updateInput(input) {
    var limit = getLimit(input);
    var counter = getCounter(input);

    if (!limit) {
      if (counter) counter.remove();
      return;
    }

    if (!counter) {
      counter = document.createElement('span');
      counter.className = COUNT_CLASS;
      counter.setAttribute('aria-live', 'polite');
      input.insertAdjacentElement('afterend', counter);
    }

    var length = input.value.length;
    var atLimit = length >= limit;
    var text = atLimit
      ? length + ' / ' + limit + '　' + limit + '文字以内にしてください' /* 「最大〇文字までです」から変更 2026.10.26 */
      : length + ' / ' + limit;

    /* 変わった時だけ書き換える */
    if (counter.textContent !== text) counter.textContent = text;
    if (counter.classList.contains('is-limit') !== atLimit) {
      counter.classList.toggle('is-limit', atLimit);
    }
  }

  function updateAll() {
    timer = null;

    document.querySelectorAll(FIELD_SELECTOR).forEach(updateInput);
  }

  function schedule() {
    if (timer) return;
    timer = window.setTimeout(updateAll, 60);
  }

  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    addStyle();

    observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, subtree: true });

    document.addEventListener('input', function (event) {
      if (event.target.closest && event.target.closest('#infiniteoptions-container')) {
        schedule();
      }
    });

    attached = true;
    updateAll();
    return true;
  }

  function start() {
    if (attach()) return;

    var tries = 0;
    var waiter = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(waiter);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 文字数の表示（入力欄の上限）ここまで */
